<template>
  <a-card :bordered="false">
    <a-form class="m-b-20" ref='form' :model='search' :initialValues="search" :onFinish='pageSearchChange' layout='inline'>
      <a-form-item label="" name='keyword'>
        <a-input-group compact :style="{width:'360px'}">
          <a-select v-model:value="search.key_type" style="width: 30%" @change="inputSelect">
            <a-select-option value="product_name">商品名称</a-select-option>
            <a-select-option value="product_sn">商品编号</a-select-option>
          </a-select>
          <a-input style="width: 70%" v-model:value="search.keyword" placeholder="请输入关键词进行搜索" />
        </a-input-group>
      </a-form-item>
      <a-form-item label="仓库名称" name='warehouse_id'>
        <a-select v-model:value="search.warehouse_id" :style="{width:'140px'}" placeholder="全部">
          <a-select-option value="">全部</a-select-option>
          <a-select-option v-for='item in warehouseList' :key='item.id' :value="item.id">{{item.name}}
          </a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item>
        <a-button type="primary" htmlType='submit'>搜索</a-button>
      </a-form-item>
    </a-form>
    <p class="p-b-20">库存总数量：{{allNum}}</p>
    <a-table :pagination='false' :loading='listLoading' bordered :columns='columns' :data-source='list'>
      <template v-slot:code="{ record }">
         <div v-if="record.product_sku_sn!=='0'">{{record.product_sku_sn}}</div>
          <div v-else>{{record.product_sn}}</div>
      </template>
       <template v-slot:product_name="{ record }">
           <a-card-meta>
            <template #avatar>
              <!-- <img :src="info.picdomain+'/'+(record.product_image_url||record.cover_image_url)" alt=""
                style="width:50px;height: 50px;object-fit:cover"> -->
            </template>
            <template #description>   {{record.product_sku_name || '单规格'}} - {{record.product_name}}</template>
          </a-card-meta>
      </template>
    </a-table>
    <a-pagination :style="{marginTop:'20px',textAlign:'right'}" show-size-changer show-quick-jumper :current="search.page"
      :page-size="search.limit" :total="total" @change="pageCurrentChange" @showSizeChange="pageSizeChange" :show-total="total => `总数: ${total} `" />
  </a-card>
</template>
<script>
  import { ref, onMounted, inject, reactive, toRefs } from "vue";
  import { message } from "ant-design-vue";
  import { getRouter } from "@/utils/app";
  import { setPageState, getPageState } from "@/utils/pageState";
  import { iscode } from "@/utils/app";
  import useTableSearch from "@/hooks/useTableSearch";
  import { getStock, getWarehouseList } from "@/api/antiFleeing";
  import store from '@/store'
  // 初始化默认筛选项数值
  let defSearch = {
    start_time: "",
    end_time: "",
    warehouse_id: "",
    page: 1,
    limit: 10,
    key_type: "product_name",
    keyword: ""
  };
  export default {
    components: {},
    setup() {
      const state = reactive({
        warehouseList:[]
      });
      let columns = [
        {
          title: "商品编码",
          // dataIndex: "product_sn",
           key: "product_sn",
           slots: { customRender: "code" },
        },
        {
          title: "商品名称",
          dataIndex: "product_name",
          key: "product_name",
          slots: { customRender: "product_name" },
        },
        {
          title: "商品规格",
          dataIndex: "product_sku_name",
          key: "product_sku_name",
          customRender:({record})=>{
            return record.product_sku_name ? record.product_sku_name:'单规格'
          } 
        },
        {
          title: "入库数量",
          dataIndex: "warehouse_num",
          key: "warehouse_num",
        },
        {
          title: "出库数量",
          dataIndex: "out_warehouse_num",
          key: "out_warehouse_num",
        },
          {
          title: "退货数量",
          dataIndex: "refund_warehouse_num",
          key: "refund_warehouse_num",
        },
        {
          title: "库存数量",
          dataIndex: "product_num",
          key: "product_num",
        },
      ];
      const $router = inject("$router");
      const $Modal = inject("$Modal");
      // 获取仓库
      const getWarehouse = async () => {
        let res = await getWarehouseList().then(res => res.data);
        if (iscode(res)) {
          state.warehouseList = res.data;
        } else {
          message.error(res.msg);
        }
      }
      const {
        pageCurrentChange,
        pageSizeChange,
        search,
        list,
        initData,
        total,
        pageSearchChange,
        listLoading,
        allNum
      } = useTableSearch({ data: defSearch });
      const tableHoosks = {
        pageCurrentChange,
        pageSizeChange,
        search,
        initData,
        list,
        total,
        pageSearchChange,
        listLoading,
        allNum
      };

      onMounted(() => {
        // 查看是否有留存状态，有则替换
        let pageState = getPageState(getRouter().route.path);
        if (pageState) {
          search.value = Object.assign(search.value, pageState);
        }
        tableHoosks.initData(getStock, {...search.value});
        getWarehouse();
      });
      return {
        ...toRefs(state),
        ...tableHoosks,
        columns,
          info: store.state.user.info,
      };
    },
  };
</script>